import '../css/Footer.css';

const Footer = () => {
    return (
        <div className='footer-div'>
            <h2>Lets work together!</h2>
            <div className='footer-icons'>
                <a href='https://www.linkedin.com/in/arundhati-bandopadhyaya-519162191/'><img src={require('../assets/footer/linkedin-icon.png')} alt='linkedin'/></a>
                <a href='https://dribbble.com/overReacting'><img src={require('../assets/footer/dribbble-icon.png')} alt='dribbble'/></a>
                <a href='https://github.com/Arundhati1234'><img src={require('../assets/footer/github-icon.png')} alt='github'/></a>
                <a href='https://codepen.io/overReacting'><img src={require('../assets/footer/codepen-icon.png')} alt='codepen'/></a>
                <a href='mailto:arundhatib.work@gmail.com'><img src={require('../assets/footer/mail-icon.png')} alt='mail'/></a>
            </div>
        </div>
    );
}

export default Footer;